import axios from "axios";
import React, { useState } from "react";
import { GET_BASE_URL } from "../utils/Constants";
import AddGames from "./AddGames";
import ModifyGame from "./ModifyGame";
import SelectedTabImageAdd from "../assets/res/add_white.svg"
import UnSelectedTabImageAdd from "../assets/res/add_black.svg"
import SelectedTabImageModify from "../assets/res/modify_white.svg"
import UnSelectedTabImageModify from "../assets/res/modify_black.svg"
import TabButton from "../components/TabButton";

const AdminPanel = () => {
  const [selectedPage, setSelectedPage] = useState("add_game");

  return (
    <div className="flex flex-row ">


      <div className="flex flex-row flex-1 ">
        <div className="flex flex-col semiBold text-3xl bg-white h-screen text-white border-r-[1px]  border-gray-300">
          <div className=" p-[16px] text-black border-b-[1px] border-gray-300 pr-[64px] ">Duck Arena</div>

          <div className="h-[16px]"></div>
          <TabButton
            label="Add Game"
            pageKey="add_game"
            selectedPage={selectedPage}
            setSelectedPage={() => setSelectedPage("add_game")}
            selectedImage={SelectedTabImageAdd}
            unselectedImage={UnSelectedTabImageAdd}
          />
          <div className="h-[8px]"></div>
          <TabButton
            label="Modify Game"
            pageKey="modify_game"
            selectedPage={selectedPage}
            setSelectedPage={() => setSelectedPage("modify_game")}
            selectedImage={SelectedTabImageModify}
            unselectedImage={UnSelectedTabImageModify}
          />
        </div>

        {selectedPage === "add_game" && <AddGames />}
        {selectedPage === "modify_game" && <ModifyGame />}
      </div>
    </div>
  );
};

export default AdminPanel;
